/* lib/decimal.js — ввод десятичных чисел: точка и запятая равнозначны (RU-раскладка).
   normalizeDecimalText — для value текстового инпута: чистит мусор, «,» → «.»,
   сохраняет незавершённый ввод («561.», «-»). parseDecimal — терпимый Number()
   поверх той же эквивалентности (пусто/мусор → NaN, у вызывающего свой guard). */

export const normalizeDecimalText = (s) =>
  String(s ?? '').replace(/[^\d.,\-]/g, '').replace(/,/g, '.');

export const parseDecimal = (v) =>
  (v === '' || v == null) ? NaN : Number(String(v).replace(/,/g, '.'));
